import { connectWallet } from "./blockchain";

import React, { useState, useEffect } from 'react';
import { 
  ShieldCheck, 
  UserPlus, 
  Vote,
  LayoutDashboard, 
  History,
  AlertCircle, 
  CheckCircle2, 
  Clock, 
  ChevronRight, 
  Plus, 
  Lock, 
  Unlock, 
  Wallet,
  ArrowRight,
  Activity,
  Search,
  Bell,
  Cpu,
  Globe,
  Zap,
  TrendingUp,
  Fingerprint
} from 'lucide-react';

const BottomNav = ({ activeTab, setActiveTab }) => {
  const items = [
    { id: 'dashboard', icon: LayoutDashboard, label: 'Home' },
    { id: 'elections', icon: Cpu, label: 'Elections' },
    { id: 'proposals', icon: Vote, label: 'Proposals' },
    { id: 'results', icon: TrendingUp, label: 'Results' },
    { id: 'history', icon: History, label: 'History' },
    { id: 'register', icon: UserPlus, label: 'Identity' },
    { id: 'profile', icon: Fingerprint, label: 'Profile' },
  ];


  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-slate-950/90 backdrop-blur-2xl border-t border-white/5 px-2 pb-8 pt-2 z-50">
      <div className="flex md:justify-around gap-2 overflow-x-auto md:overflow-visible no-scrollbar px-2">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`min-w-[72px] md:min-w-0 flex flex-col items-center gap-1.5 py-2 px-3 rounded-2xl transition-all duration-300 ${
              activeTab === item.id ? 'text-indigo-400 scale-105' : 'text-slate-500'
            }`}
          >
            <item.icon size={22} strokeWidth={activeTab === item.id ? 2.5 : 2} />
            <span className="text-[10px] font-bold uppercase tracking-widest">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};


export default function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [walletConnected, setWalletConnected] = useState(false);
  const [address, setAddress] = useState('');
  const [notif, setNotif] = useState(null);
  const [duration, setDuration] = useState(60);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [days, setDays] = useState("");
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [proposals, setProposals] = useState({});
  const [proposalCount, setProposalCount] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [proposalData, setProposalData] = useState({});
  const [userVotes, setUserVotes] = useState(0);
  const [pending, setPending] = useState({});
  const [isOfficer, setIsOfficer] = useState(false);
  const [myVotes, setMyVotes] = useState([]);
  const [historyUnlocked, setHistoryUnlocked] = useState(false);
  const [featured, setFeatured] = useState(null);
  const [participation, setParticipation] = useState(0);
  const [rank, setRank] = useState("-");
  const [newOfficer, setNewOfficer] = useState("");


const handleConnect = async () => {
  try {
    const { account, contract } = await connectWallet();
    window.dao = contract;
    window.ethereum.on("accountsChanged", handleLogout);
    setAddress(account);
    setWalletConnected(true);
    triggerNotif("Wallet Connected");
  } catch (err) {
    alert("MetaMask not detected");
  }
};

const handleLogout = () => {
  setWalletConnected(false);
  setAddress("");
  setProposalData({});
  setProposalCount(0);
  setUserVotes(0);
  setActiveTab("dashboard");
  triggerNotif("Logged out");
};


  const triggerNotif = (msg) => {
    setNotif(msg);
    setTimeout(() => setNotif(null), 3000);
  };

  useEffect(() => {
    async function load() {
      if (!window.dao || !address) return;

      const admin = await window.dao.admin();
      const officer = await window.dao.isOfficer(address);
      setIsOfficer(officer || admin.toLowerCase() === address.toLowerCase());

      if (admin && address) {
        setIsAdmin(admin.toLowerCase() === address.toLowerCase());
      }

      const data = {};
      const count = await window.dao.proposalCount();
      setProposalCount(Number(count));
      for (let id = 1; id <= Number(count); id++) {

        const p = await window.dao.getProposal(id);
        const now = Math.floor(Date.now() / 1000);
        const isClosed = now >= Number(p[4]);

        const voted = await window.dao.hasVoted(id, address);

        data[id] = {
          title: p[0],
          desc: p[1],
          yes: Number(p[2]),
          no: Number(p[3]),
          end: Number(p[4]),
          voted,
          closed: isClosed
        };

      }
      setProposals(data);

      const pendingCount = await window.dao.pendingElectionCount();
      const pend = {};

      for (let i = 1; i <= Number(pendingCount); i++) {
        const p = await window.dao.pendingElections(i);

        const created = p[4];
        const approvals = Number(p[3]);

        if (!created && approvals < 2) {
          pend[i] = {
            title: p[0],
            desc: p[1],
            approvals
          };
        }
      }

      setPending(pend);
    }

    load();
  }, [address, notif]);


  useEffect(() => {
    const t = setInterval(() => {
      setProposals(p => ({ ...p }));
    }, 60000);
    return () => clearInterval(t);
  }, []);


  useEffect(() => {
    async function loadDAO() {
      if (!window.dao || !address) return;

      const count = await window.dao.proposalCount();
      setProposalCount(Number(count));
      const total = Number(count);

      let votedCount = 0;
      const data = {};

      for (let i = 1; i <= total; i++) {
        const p = await window.dao.getProposal(i);
        const voted = await window.dao.hasVoted(i, address);

        if (voted) votedCount++;

        const end = Number(p[4]);

        data[i] = {
          title: p[0],
          desc: p[1],
          yes: Number(p[2]),
          no: Number(p[3]),
          end,
          voted,
          closed: Date.now() / 1000 >= end
        };
      }

      setProposalData(data);
      setUserVotes(votedCount);
      if (count > 0) {
        const pct = Math.round((votedCount / total) * 100);
        setParticipation(pct);
      }
      let newest = null;
      for (let i = total; i >= 1; i--) {
        const p = data[i];
        if (p && !p.closed) {
          newest = { id: i, ...p };
          break;
        }
      }
      setFeatured(newest);
      setRank( Math.max(1, 100 - votedCount * 7) );
      setMyVotes(getMyVotes());
    }

    loadDAO();
  }, [address, walletConnected, notif]);


  function getMyVotes() {
    const votes = [];

    for (let i = 1; i <= proposalCount; i++) {
      const raw = localStorage.getItem(`vote-${i}`);
      if (!raw) continue;

      try {
        const data = JSON.parse(raw);
        if (!data.tx || !data.time) continue;

        votes.push({
          id: i,
          tx: data.tx,
          time: data.time,
          title: proposals[i]?.title || proposalData[i]?.title || `Proposal ${i}`
        });
      } catch {
        localStorage.removeItem(`vote-${i}`);
      }
    }

    return votes;
  }


  function getLastVote() {
    if (!myVotes || myVotes.length === 0) return null;

    return myVotes.sort((a, b) => b.time - a.time)[0];
  }

  const unlockHistory = async () => {
    try {
      const msg = "Unlock my voting history";
      await window.ethereum.request({
        method: "eth_requestAccounts"
      });

      await window.ethereum.request({
        method: "personal_sign",
        params: [msg, address]
      });

      const votes = [];

      for (let i = 1; i <= proposalCount; i++) {
        const raw = localStorage.getItem(`vote-${i}`);
        if (!raw) continue;

        const data = JSON.parse(raw);
        votes.push({
          id: i,
          tx: data.tx,
          time: data.time,
          title: proposalData[i]?.title || `Proposal ${i}`
        });
      }

      setMyVotes(votes);
      setHistoryUnlocked(true);
      triggerNotif("History Unlocked");
    } catch {
      alert("Authentication failed");
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return (
          <div className="animate-in px-6 pt-8">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-3xl font-black tracking-tight text-white mb-1">Hello, NiKHiL</h2>
                <p className="text-slate-500 text-xs font-medium">Your assets are secured on-chain.</p>
              </div>
              {walletConnected && (
                <div className="bg-white/5 border border-white/10 px-3 py-1.5 rounded-lg">
                   <p className="text-[9px] font-mono text-indigo-400">{address}</p>
                </div>
              )}
            </div>

            <div className="grid grid-cols-1 gap-4 mb-8">
              <div className="bg-gradient-to-br from-indigo-600 via-indigo-700 to-indigo-800 p-6 rounded-[32px] shadow-2xl shadow-indigo-600/20 relative overflow-hidden group">
                <div className="relative z-10">
                  <div className="flex justify-between items-start mb-6">
                    <div className="p-3 bg-white/10 rounded-2xl backdrop-blur-md">
                      <TrendingUp size={24} className="text-white" />
                    </div>
                    <div className="flex flex-col items-end">
                      <span className="text-[10px] font-black text-white/50 uppercase tracking-widest mb-1">Total Stake</span>
                      <p className="text-lg font-mono text-white">4.82 ETH</p>
                    </div>
                  </div>
                  <p className="text-[10px] font-bold text-indigo-200 uppercase tracking-widest mb-1 opacity-70">Voting Power</p>
                  <div className="flex items-baseline gap-2">
                    <p className="text-4xl font-black text-white tracking-tighter">12,490</p>
                    <span className="text-sm font-bold text-white/50">VP</span>
                  </div>
                </div>
                <Activity className="absolute -bottom-10 -right-10 text-white/5 group-hover:text-white/10 transition-colors" size={200} />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-10">
              <div className="bg-slate-900 border border-white/5 p-5 rounded-3xl">
                <Zap size={18} className="text-amber-400 mb-3" />
                <p className="text-[9px] font-bold text-slate-500 uppercase tracking-widest mb-1">Participation</p>
                <p className="text-xl font-black text-white tracking-tight">{participation}%</p>
              </div>
              <div className="bg-slate-900 border border-white/5 p-5 rounded-3xl">
                <Globe size={18} className="text-blue-400 mb-3" />
                <p className="text-[9px] font-bold text-slate-500 uppercase tracking-widest mb-1">DAO Voting Rank</p>
                <p className="text-xl font-black text-white tracking-tight">#{rank}</p>
              </div>
            </div>

            <div className="mb-6 flex justify-between items-end">
              <h3 className="text-xs font-black text-slate-500 uppercase tracking-[0.2em]">Featured Proposal</h3>
              <button className="text-[10px] font-bold text-indigo-400" onClick={() => {
                                                                          if (featured) setActiveTab("proposals");
                                                                        }}>View All
              </button>
            </div>
            
            <div className="bg-slate-900 border border-white/5 rounded-[40px] p-8 mb-10 relative overflow-hidden">
              <div className="flex items-center gap-2 mb-4">
                <span className="px-2 py-0.5 bg-emerald-500/10 text-emerald-500 text-[9px] font-black uppercase tracking-widest rounded border border-emerald-500/20">
                  Critical
                </span>
                <span className="text-[9px] font-bold text-slate-600 uppercase">{featured
                                                                                  ? `Ends in ${Math.max(0, Math.floor((featured.end - Math.floor(Date.now()/1000)) / 60))} min`
                                                                                  : "No active election"}
                </span>
              </div>
              <h3 className="text-xl font-black text-white mb-3 leading-tight">
                {featured ? featured.title : "No active proposals"}
              </h3>
              <button onClick={() => {
                        if (featured) setActiveTab("proposals");
                      }} className="w-full py-4 bg-white text-slate-950 rounded-2xl text-[10px] font-black uppercase tracking-widest flex items-center justify-center gap-2">
                Submit Vote <ArrowRight size={14} />
              </button>
            </div>
          </div>
        );
      case 'proposals':

        return (
          <div className="animate-in px-6 pt-8 space-y-6">
            <h2 className="text-3xl font-black text-white tracking-tighter">Proposals</h2>
            
            {walletConnected && (
            <div className="bg-slate-900 border border-white/10 rounded-3xl p-6 mb-8">
            <h3 className="text-white font-black mb-4">Create Proposal</h3>

            <input
              className="w-full p-3 mb-3 bg-slate-800 rounded-xl text-white"
              placeholder="Proposal Title"
              value={title}
              onChange={e => setTitle(e.target.value)}
            />

            <textarea
              className="w-full p-3 mb-4 bg-slate-800 rounded-xl text-white"
              placeholder="Proposal Description"
              value={desc}
              onChange={e => setDesc(e.target.value)}
            />

            <div className="grid grid-cols-3 gap-3 mb-4">
              <input
                type="number"
                min="0"
                placeholder="Days"
                value={days}
                onChange={e => setDays(e.target.value)}
                className="p-3 bg-slate-800 rounded-xl text-white"
              />
              <input
                type="number"
                min="0"
                placeholder="Hours"
                value={hours}
                onChange={e => setHours(e.target.value)}
                className="p-3 bg-slate-800 rounded-xl text-white"
              />
              <input
                type="number"
                min="0"
                placeholder="Minutes"
                value={minutes}
                onChange={e => setMinutes(e.target.value)}
                className="p-3 bg-slate-800 rounded-xl text-white"
              />
            </div>


            <button
              onClick={async () => {
                try {
                  const totalMinutes =
                  (Number(days) * 24 * 60) +
                  (Number(hours) * 60) +
                  Number(minutes);

                  if (totalMinutes <= 0) {
                    alert("Please set a valid voting duration");
                    return;
                  }

                  const tx = await window.dao.proposeElection(title, desc, totalMinutes);

                  await tx.wait();
                  triggerNotif("Election proposed — Waiting for Approval");
                } catch (err) {
                  if (err.message.includes("Not admin")) {
                    alert("Only Admins can create proposals");
                  } else {
                    alert("Transaction failed");
                  }
                }
              }}
              className="w-full py-3 bg-indigo-600 rounded-xl font-black text-white"
            >
              Create Proposal
            </button>
            </div>
            )}

            {[...Array(proposalCount)].map((_, i) => {
              const pid = i + 1;

              const p = proposals[pid] || { yes:0, no:0, voted:false };

              const total = p.yes + p.no || 1;
              const percent = (p.yes / total) * 100;

              const now = Math.floor(Date.now() / 1000);
              const timeLeft = Math.max(0, (p.end || 0) - now);
              const mins = Math.floor(timeLeft / 60);

              return (
                <div key={pid} className="bg-slate-900 border border-white/5 rounded-[32px] p-6 shadow-xl">
                  
                  <h4 className="text-lg font-black text-white mb-2">
                    {p.title}
                  </h4>

                  <p className="text-xs text-slate-400 mb-4">
                    {p.desc}
                  </p>

                  <div className="h-1.5 w-full bg-slate-800 rounded-full mb-2">
                    <div className="h-full bg-indigo-500" style={{ width: `${percent}%` }} />
                  </div>

                  <p className="text-xs text-slate-400 mb-3">
                    Yes: {p.yes} · No: {p.no}
                  </p>

                <p className="text-xs text-amber-400 mb-3">
                  {timeLeft === 0 ? "Voting Closed" : `Ends in ${mins} min`}
                </p>


                  <div className="flex gap-3">
                    <button
                      disabled={p.voted || p.closed}
                      onClick={async () => {
                        try {
                          const tx = await window.dao.vote(pid, true);
                          await tx.wait();
                          localStorage.setItem(`vote-${pid}`, JSON.stringify({
                            tx: tx.hash,
                            time: Date.now()
                          }));

                          triggerNotif("Vote Recorded");
                        } catch (err) {
                          if (err.code === 4001) {
                            triggerNotif("Vote Cancelled");
                          } else {
                            alert("Transaction Failed");
                          }
                        }
                      }}
                      className={`flex-1 py-3 rounded-xl ${
                        p.voted ? "bg-slate-700" : "bg-indigo-600 text-white"
                      }`}
                    >
                      {p.closed ? "Voting Closed" : "Vote YES"}
                    </button>

                    <button
                      disabled={p.voted || p.closed}
                      onClick={async () => {
                        try {
                          const tx = await window.dao.vote(pid, false);
                          await tx.wait();
                          localStorage.setItem(`vote-${pid}`, JSON.stringify({
                            tx: tx.hash,
                            time: Date.now()
                          }));

                          triggerNotif("Vote Recorded");
                        } catch (err) {
                          if (err.code === 4001) {
                            triggerNotif("Vote Cancelled");
                          } else {
                            alert("Transaction Failed");
                          }
                        }
                      }}
                      className={`flex-1 py-3 rounded-xl ${
                        p.voted ? "bg-slate-700" : "bg-slate-800 text-white"
                      }`}
                    >
                      {p.closed ? "Voting Closed" : "Vote NO"}
                    </button>
                  </div>

                  {p.voted && <p className="text-emerald-400 text-xs mt-2">You voted</p>}

                </div>
              );
            })}

          </div>
        );


      case "elections":
        return (
          <div className="animate-in px-6 pt-8 space-y-6">

            {isOfficer && Object.entries(pending).map(([id,p])=>(
            <div key={id} className="bg-slate-900 border border-white/10 rounded-3xl p-6 mb-8">
              <p className="text-white font-black">{p.title}</p>
              <p className="text-slate-400 text-xs">{p.desc}</p>
              <p className="text-amber-400 text-xs">Approvals: {p.approvals}/2</p>

              <button
                disabled={p.approvals >= 2}
                onClick={async () => {
                  try {
                    if (isAdmin) {
                      await window.ethereum.request({ method: "eth_requestAccounts" });
                      const tx = await window.dao.adminCreateElection(Number(id));
                      await tx.wait();
                      triggerNotif("Approved by Admin");
                    } else {
                      await window.ethereum.request({ method: "eth_requestAccounts" });
                      const tx = await window.dao.approveElection(Number(id));
                      await tx.wait();

                      triggerNotif("Approval Submitted");
                    }
                    setNotif(Date.now());
                  } catch (e) {
                    alert(e.reason || "Approval Failed");
                  }
                }}

                className="w-full mt-3 py-3 bg-indigo-600 rounded-xl font-black text-white"
              >
                Approve Election
              </button>
            </div>
          ))}

            {Object.entries(proposalData)
              .filter(([_, e]) => !e.closed)
              .map(([id, e]) => {
              const total = e.yes + e.no || 1;
              const pct = Math.min(100, Math.round((total / (proposalCount * 10 || 1)) * 100));

              return (
                <div key={id} className="bg-slate-900 border border-white/5 rounded-[32px] p-6 shadow-xl">
                  <p className="text-white font-black">{e.title}</p>
                  <p className="text-slate-400 text-xs">{e.desc}</p>
                  <div className="h-2 bg-slate-800 rounded-full mt-3">
                    <div className="h-full bg-indigo-500 rounded-full" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        );


      case "results":
        return (
          <div className="animate-in px-6 pt-8 space-y-6">
            {Object.entries(proposalData)
              .filter(([_, r]) => r.closed)
              .map(([id, r]) => {
              const total = r.yes + r.no || 1;
              const yesPct = Math.round((r.yes / total) * 100);
              const noPct = 100 - yesPct;
              const winner =
                r.yes > r.no ? "Yes" :
                r.no > r.yes ? "No" :
                "Tie";
            
            <button
              className="mt-3 w-full py-3 bg-slate-800 rounded-xl text-indigo-400 text-xs font-bold"
              onClick={() => {
                const hash = localStorage.getItem(`vote-${id}`);
                if (!hash) {
                  alert("You did not vote on this proposal");
                  return;
                }
                window.open(`https://sepolia.etherscan.io/tx/${hash}`, "_blank");
              }}
            >
              Verify My Vote on Blockchain
            </button>


              return (
                <div key={id} className="bg-slate-900 border border-white/5 rounded-[32px] p-6 shadow-xl">
                  <p className="text-white font-black">{r.title}</p>
                  <p className="text-emerald-400">Winner: {winner}</p>
                  <p className="text-slate-400 text-xs">Yes {yesPct}% · No {noPct}%</p>
                  <p className="text-indigo-400 text-[10px]">Blockchain Verified ✓</p>
                </div>
              );
            })}
          </div>
        );


      case 'history':
        return (
          <div className="animate-in pt-16 flex flex-col items-center px-6">
             <div className="w-20 h-20 bg-slate-900 border border-white/10 rounded-full flex items-center justify-center mb-6">
                <Unlock size={24} className="text-slate-600" />
             </div>
             <h3 className="text-xl font-black text-white mb-2">Vault Encrypted</h3>
             <p className="text-slate-500 text-xs font-medium text-center mb-10 leading-relaxed">Personal vote history is stored locally. Sign a session key to view decrypted records.</p>
             <button
              onClick={unlockHistory}
              className="px-10 py-4 bg-slate-900 border border-white/10 rounded-3xl text-[10px] font-black uppercase tracking-widest text-indigo-400"
            >
              Authenticate History
            </button>

            {historyUnlocked && (
              <div className="mt-10 w-full space-y-4">
                {myVotes.length === 0 && (
                  <p className="text-slate-500 text-xs text-center">
                    No votes recorded yet
                  </p>
                )}

                {myVotes.map(v => (
                  <div
                    key={v.id}
                    className="bg-slate-900 border border-white/10 rounded-2xl p-4"
                  >
                    <p className="text-white font-bold">{v.title}</p>
                    <p className="text-xs text-slate-400">
                      {new Date(v.time).toLocaleString()}
                    </p>

                    <button
                      onClick={() =>
                        window.open(`https://sepolia.etherscan.io/tx/${v.tx}`, "_blank")
                      }
                      className="mt-2 w-full py-2 bg-indigo-600 rounded-xl text-xs font-bold"
                    >
                      Verify on Blockchain
                    </button>
                  </div>
                ))}
              </div>
            )}

          </div>
        );

      case 'register':
        return (
          <div className="animate-in px-6 pt-12 flex flex-col items-center">
            <div className="w-24 h-24 bg-gradient-to-tr from-indigo-600 to-indigo-400 rounded-[40px] flex items-center justify-center mb-8 shadow-2xl">
              <Fingerprint size={40} className="text-white" />
            </div>
            <h2 className="text-3xl font-black text-white mb-4 tracking-tighter">Identity Vault</h2>
            <p className="text-slate-500 text-sm font-medium text-center mb-12">Mint your Zero-Knowledge ID to participate in anonymous governance.</p>
            <button disabled={!walletConnected} className="w-full py-5 bg-indigo-600 disabled:opacity-30 text-white rounded-[24px] font-black uppercase tracking-widest">Initiate Mint Sequence</button>
            {!walletConnected && <p className="text-rose-500 text-[10px] mt-4 font-bold uppercase tracking-widest">Connect Wallet to Begin</p>}
          </div>
        );


      case "profile":
        return (
          <div className="animate-in px-6 pt-8 space-y-6">

            <div className="bg-slate-900 border border-white/5 rounded-[32px] p-6 shadow-xl">
              <p className="text-white font-black text-xl">NiKHiL 7x7</p>
              <p className="text-slate-400 text-sm">Student ID : 992501030204</p>
              <p className="text-indigo-400 text-xs font-mono">satya_8fc8fxy76c38za5dc17</p>
            </div>

            <div className="grid grid-cols-3 gap-4">
              {[
                ["Votes", userVotes],
                ["Elections", proposalCount ],
                ["Last Vote", new Date().toLocaleDateString()]
              ].map(([k,v])=>(
                <div key={k} className="bg-slate-900 border border-white/5 rounded-2xl p-4 text-center">
                  <p className="text-slate-400 text-xs">{k}</p>
                  <p className="text-white font-black">{v}</p>
                </div>
              ))}
              <p className="text-[10px] text-slate-400 mt-2">
                Last vote tx: {localStorage.getItem("vote-1")?.slice(0,10)}…
              </p>
            </div>

            <div className="bg-slate-900 border border-white/5 rounded-[32px] p-6 space-y-3">
              {["Verified by College","One-person-one-vote","Blockchain verified"].map(t=>(
                <div key={t} className="flex justify-between text-sm text-white">
                  <span>{t}</span>
                  <span className="text-emerald-400">✓</span>
                </div>
              ))}
            </div>

            <div className="space-y-3">
              <button
                className="w-full py-4 bg-indigo-600 rounded-xl"
                onClick={() => {
                  if (myVotes.length === 0) {
                    alert("You have not voted yet");
                    return;
                  }

                  const list = myVotes
                    .map(v => `Proposal ${v.id}: ${v.tx}`)
                    .join("\n\n");

                  alert("Your Votes:\n\n" + list);
                }}
              >
                View My Votes
              </button>

              <button
                className="w-full py-4 bg-slate-800 rounded-xl"
                onClick={() => {
                  const last = getLastVote();
                  if (!last) {
                    alert("No votes found");
                    return;
                  }

                  window.open(
                    `https://sepolia.etherscan.io/tx/${last.tx}`,
                    "_blank"
                  );
                }}
              >
                Verify My Last Vote
              </button>

              {isAdmin && (
                <div className="bg-slate-900 border border-indigo-500/30 rounded-2xl p-4 mt-4">
                  <p className="text-indigo-400 text-xs font-bold mb-2">ADMIN CONTROLS</p>

                  <input
                    placeholder="Officer wallet address"
                    className="w-full p-3 bg-slate-800 rounded-xl text-white mb-2"
                    onChange={(e) => setNewOfficer(e.target.value)}
                  />

                  <button
                    onClick={async () => {
                      try {
                        const tx = await window.dao.addOfficer(newOfficer);
                        await tx.wait();
                        triggerNotif("Officer added");
                      } catch (e) {
                        alert("Only admin can add officers");
                      }
                    }}
                    className="w-full py-3 bg-indigo-600 rounded-xl text-white font-black"
                  >
                    Add Election Officer
                  </button>
                </div>
              )}

              <button
                onClick={handleLogout}
                className="w-full py-4 bg-rose-600 rounded-xl"
              >
                Logout
              </button>

            </div>

          </div>
        );


      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-sans pb-28 selection:bg-indigo-500/30">
      {notif && (
        <div className="fixed top-12 left-1/2 -translate-x-1/2 bg-indigo-600/95 backdrop-blur-md text-white px-6 py-3 rounded-full text-[10px] font-black uppercase tracking-widest shadow-2xl z-[100] animate-in">
          <div className="flex items-center gap-2">
            <CheckCircle2 size={14} />
            {notif}
          </div>
        </div>
      )}

      <header className="h-20 flex items-center justify-between px-6 sticky top-0 bg-slate-950/80 backdrop-blur-xl border-b border-white/5 z-40">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-indigo-600 rounded-2xl flex items-center justify-center shadow-lg shadow-indigo-600/20">
            <ShieldCheck size={20} className="text-white" />
          </div>
          <div>
            <h1 className="font-black text-[20px] tracking-widest uppercase text-white/50 mb-0.5">
              Satya Vote
            </h1>

            {isAdmin && (
              <span className="mt-1 inline-block px-2 py-0.5 bg-indigo-500/20 text-indigo-400 text-[8px] font-black uppercase tracking-widest rounded border border-indigo-500/30">
                DAO Admin
              </span>
            )}

            <div className="flex items-center gap-1.5">
              <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></div>
              <span className="text-[15px] text-slate-400 tracking-tighter">Decentralised Voting</span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button className="relative p-2.5 bg-white/5 rounded-xl border border-white/5">
            <Bell size={18} className="text-slate-400" />
            <div className="absolute top-2.5 right-2.5 w-1.5 h-1.5 bg-rose-500 rounded-full"></div>
          </button>
          {!walletConnected ? (
            <button onClick={handleConnect} className="px-4 py-2 bg-indigo-600 rounded-xl text-[10px] font-black uppercase tracking-widest text-white">Sign In</button>
          ) : (
            <div className="w-10 h-10 rounded-xl bg-indigo-500/10 border border-indigo-500/20 flex items-center justify-center text-indigo-400"><Fingerprint size={20} /></div>
          )}
        </div>
      </header>

      <main className="flex-1 overflow-x-hidden">
        {renderContent()}
      </main>

      <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes fade-in { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-in { animation: fade-in 0.4s ease-out forwards; }

        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }

        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}} />
    </div>
  );
}